var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(_vm.deviceIphone == false)?_c('PostForm'):_vm._e(),(_vm.deviceIphone == true)?_c('IphonePostForm'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }